import Image from "next/image";
import humanRing from "@/public/home/emotions/human-ring.svg";

/**
 * Orange ring "human" icon rendered inline with text (Emotions headline).
 * Wrapped in `not-prose` with inline styles so `.richtext` (tailwind
 * typography) cannot turn the image into a block with 2em margins.
 */
export default function HumanRingIcon() {
  return (
    <span
      className="not-prose"
      style={{ display: "inline-flex", verticalAlign: "-0.06em", margin: "0 0.12em", lineHeight: 0 }}>
      <Image
        src={humanRing}
        alt=""
        style={{ display: "block", width: "0.72em", height: "0.72em", margin: 0 }}
      />
    </span>
  );
}
